import { useState } from 'react'
import useMountedRef from '@aytm/lib/hooks/useMountedRef'

import style from './Copy.module.scss'

export default function Copy({ blockType: _blockType, content }: { blockType: string; content: string }) {
  const [justCopied, setJustCopied] = useState<boolean>(false)
  const mountedRef = useMountedRef()

  return (
    <div
      className={style.Copy}
      onClick={() => {
        if (mountedRef.current) {
          setJustCopied(false)
          void navigator.clipboard.writeText(content.trim()).then(() => {
            setJustCopied(true)
            setTimeout(() => {
              if (mountedRef.current) {
                setJustCopied(false)
              }
            }, 1000)
          })
        }
      }}
    >
      <i className={`${justCopied ? 'icon-aytmfd-checkmark-rounded' : 'icon-aytmfd-copy'} ${style.Copy__icon}`} />
      {content}
    </div>
  )
}
